import React, {Suspense, useEffect, useState} from 'react';
import {useSetRecoilState, useRecoilState, useRecoilValue} from 'recoil';
import {useNavigate} from 'react-router-dom';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';

import MyInfo from '@/components/myKnewnew/MyInfo';
import EmptyInfo from '@/components/myKnewnew/EmptyInfo';
import Header from '@/layouts/Header';
import {userDetail, getUserProfile} from '@/services/user';
import BottomNavigation from '@/layouts/BottomNavigation';
import ContentsHeader from '@/layouts/ContentsHeader';
import ContentsModal from '@/components/common/ContentsModal';
import {user, UserInfo} from '@/store';
import MyPageModal from '@/components/common/MyPageModal';
import MyPageLoader from '@/components/common/Skeleton/MyPageLoader';
import {useScroll} from '@/hooks/useScroll';
import useStorage from '@/hooks/useStorage';

import MyCommunities from '../MyCommunities';

export default function Home() {
  useScroll();
  const navigator = useNavigate();
  const {getToken} = useStorage();
  const setAccessToken = useSetRecoilState(user);
  const [userInfo, setUserInfo] = useRecoilState(UserInfo);
  const [mode, setMode] = useState<'my' | 'other'>('my');
  const [profile, setProfile] = useState<UserInfoObj>();
  const accessToken = useRecoilValue(user);
  const init = async () => {
    try {
      const accessToken = await getToken();
      if (accessToken && accessToken.length > 0) {
        const res = await userDetail(accessToken);
        setUserInfo(res.data);
        setAccessToken(accessToken);
      }
    } catch (e) {
      navigator('/login', {
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      });
    }
  };

  const edit = async () => {
    navigator('/user/options');
  };

  const getProfileInfo = async (id: number) => {
    const res = await getUserProfile(id, accessToken);
    setProfile(res.data);
  };

  useEffect(() => {
    const paths = window.location.pathname.split('/');
    const isOther = !Number.isNaN(Number(paths[paths.length - 1]));

    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setStyle({
        style: Style.Light,
      });
    }
    setMode(isOther ? 'other' : 'my');
    if (!isOther && userInfo.id === -1) {
      init();
    } else if (!isOther && userInfo.id > -1) {
      setProfile({...userInfo});
    } else if (isOther) {
      getProfileInfo(Number(paths[paths.length - 1]));
    }
  }, [userInfo, window.location.pathname]);
  return (
    <div className="main my-home" style={{minHeight: '100vh'}}>
      {mode === 'my' ? (
        <>
          <Header
            title="마이페이지"
            isCommunity={false}
            isWhite={true}
            isNoRing={false}
          />
          {userInfo.id != -1 ? (
            <div className="my-knewnew-contents">
              <Suspense fallback={<MyPageLoader />}>
                <MyInfo isOther={false} profile={profile} />
                <MyCommunities isOther={false} id={profile?.id} />
              </Suspense>
            </div>
          ) : (
            <>
              <div className="my-knewnew-contents">
                <EmptyInfo />
                <MyCommunities isOther={false} id={userInfo.id} />
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <ContentsHeader isOption="none" txt={profile?.nickname} />
          <div className="my-knewnew-contents">
            <Suspense fallback={<MyPageLoader />}>
              <MyInfo isOther={true} profile={profile} />
              <MyCommunities isOther={true} id={profile?.id} />
            </Suspense>
          </div>
        </>
      )}

      <ContentsModal
        type={'contents-edit'}
        fetch={() => null}
        moveToEdit={() => edit()}
      />
      {mode === 'my' && <BottomNavigation />}
      {mode === 'my' && <MyPageModal />}
    </div>
  );
}
